import { Dispatch, Ref, SetStateAction } from 'react';
import { Loader } from 'lucide-react';
import { DataTable } from '@/components/Common';
import { HdrDetails } from '#server/models/hdr';
import { ExtendedHdrDetails, hdrColumns } from './HdrColumns';
import { ColumnFiltersState } from '@tanstack/react-table';

export interface HdrTableProps {
  parentRef: Ref<HTMLDivElement>;
  hdrDetails: HdrDetails[];
  isPageLoading: boolean;
  columnFilters?: ColumnFiltersState;
  setColumnFilters?: Dispatch<SetStateAction<ColumnFiltersState>>;
  setHasSavedHdr: React.Dispatch<React.SetStateAction<boolean>>;
}
export const HdrTable = ({
  parentRef,
  hdrDetails,
  isPageLoading,
  columnFilters,
  setColumnFilters,
  setHasSavedHdr,
}: HdrTableProps) => {
  if (isPageLoading) {
    return <Loader />;
  }
  return (
    <div className="max-h-full w-full overflow-y-auto rounded">
      <DataTable
        id="staff-unit-table"
        headerProps={{ disableDefaultBorder: false, primaryColor: 'bg-white', borderColor: 'border-secondary-grey-04' }}
        footerProps={{ disablePagination: true, className: 'h-1 border-t-2' }}
        tableProps={{
          padding: 'px-10',
          disableBottomBorder: true,
        }}
        columns={hdrColumns(setHasSavedHdr).map((column) => {
          return { ...column, parentRef };
        })}
        data={hdrDetails as unknown as ExtendedHdrDetails[]}
        columnFilters={columnFilters}
        setColumnFilters={setColumnFilters}
        isPageLoading={isPageLoading}
      />
    </div>
  );
};
